var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "tips"
  }, [_vm._v("*" + _vm._s(_vm.$t("请输入新手机号并进行短信验证")))]), _c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("新手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("新手机号"),
      maxLength: 11
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("mobile");
      }
    },
    scopedSlots: _vm._u([{
      key: "addonBefore",
      fn: function () {
        return [_c("a-select", {
          staticStyle: {
            width: "90px"
          },
          attrs: {
            dropdownClassName: "mul-select-dropdown",
            "option-label-prop": "value"
          },
          on: {
            change: _vm.changeGlobalRoaming
          },
          model: {
            value: _vm.form.globalRoaming,
            callback: function ($$v) {
              _vm.$set(_vm.form, "globalRoaming", $$v);
            },
            expression: "form.globalRoaming"
          }
        }, _vm._l(_vm.globalRoamingOptionData, function (item) {
          return _c("a-select-option", {
            key: item.label,
            attrs: {
              value: item.label
            }
          }, [_c("span", {
            attrs: {
              title: item.label + _vm.$t(item.value)
            }
          }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))])]);
        }), 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("验证码"),
      prop: "code"
    }
  }, [_c("a-input", {
    ref: "code",
    staticStyle: {
      width: "65%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("验证码"),
      maxLength: 6
    },
    on: {
      input: function ($event) {
        return _vm.codeInput("code", $event);
      },
      blur: function ($event) {
        return _vm.handleBlurTrim("code");
      }
    },
    model: {
      value: _vm.form.code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  }), _vm.textLength > 9 ? _c("a-tooltip", {
    attrs: {
      placement: "topRight"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.text)))])]), _c("a-button", {
    staticClass: "codeBtn",
    attrs: {
      size: "small",
      disabled: _vm.disable
    },
    on: {
      click: _vm.getCode
    }
  }, [_c("span", {
    staticClass: "codeText"
  }, [_vm._v(_vm._s(_vm.$t(_vm.text)))])])], 2) : _c("a-button", {
    staticClass: "codeBtn",
    attrs: {
      size: "small",
      disabled: _vm.disable
    },
    on: {
      click: _vm.getCode
    }
  }, [_c("span", {
    staticClass: "codeText"
  }, [_vm._v(_vm._s(_vm.$t(_vm.text)))])])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };